import { useDispatch, useSelector } from 'react-redux';

import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';

import React from 'react';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { Hub } from 'aws-amplify';
import { CssBaseline } from '@mui/material';
import { useEffect } from 'react';
import { SET_OPEN_MFA } from 'store/actions';

// ==============================|| APP ||============================== //

const App = () => {
    const dispatch = useDispatch();
    const customization = useSelector((state) => state.customization);
    useEffect(() => {
        const documentID = sessionStorage.getItem('documentID');
        if (documentID) {
            dispatch({ type: SET_OPEN_MFA, openApp: true });
        }
    }, []);
    // console.log('Dummy Deployment Test1');
    // Hub.listen('auth', (data) => {
    //     const { payload } = data;
    //     if (payload.event === 'signOut') {
    //         localStorage.clear();
    //         sessionStorage.clear();
    //     }
    // });

    return (
        // <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
        // </StyledEngineProvider>
    );
};

export default App;
